<template>
  <section
    class="client-accept-invitation"
    :style="{
      'background-image': 'url(' + bucketUrl + '/assets/background_client.png)'
    }"
  >
    <header-logged-out type="client" :checkuser="false" />
    <v-container fill-height>
      <v-row class="fill-height" align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="4">
          <v-card>
            <v-toolbar dark color="primary" flat>
              <v-toolbar-title>Accept Invitation To Sign Up</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <form>
                <v-text-field
                  ref="password"
                  v-model="password"
                  name="password"
                  label="Enter your password"
                  hint="Make sure your password is 6 to 20 characters long"
                  min="6"
                  :append-icon="visible ? 'visibility' : 'visibility_off'"
                  @click:append="visible = !visible"
                  :error-messages="errors.collect('password')"
                  v-validate="'required|min:6|max:20'"
                  data-vv-name="password"
                  required
                  :type="visible ? 'text' : 'password'"
                />
                <v-text-field
                  v-model="password_confirmation"
                  name="password_confirmation"
                  label="Confirm your password"
                  min="6"
                  :append-icon="visible ? 'visibility' : 'visibility_off'"
                  @click:append="visible = !visible"
                  :error-messages="errors.collect('password_confirmation')"
                  v-validate="'required|confirmed:password'"
                  data-vv-name="password_confirmation"
                  required
                  :type="visible ? 'text' : 'password'"
                />
              </form>
            </v-card-text>
            <v-card-actions class="px-3 pb-3 pt-0">
              <v-spacer />
              <v-btn color="primary" @click="submit" :loading="loading">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-snackbar
            :color="snackBarColor"
            v-model="snackbar"
            left
            :timeout="3000"
          >
            {{ snackbarMessage }}
            <v-btn dark flat @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import Client from '@/modules/client/models/Client'
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'
import { mapState } from 'vuex'

export default {
  name: 'AcceptInvitation',
  components: {
    HeaderLoggedOut
  },
  data() {
    return {
      loading: false,
      snackBarColor: 'green',
      cred: '',
      password: null,
      password_confirmation: null,
      visible: false,
      token: null,
      snackbar: false,
      snackbarMessage: '',
      id: 0
    }
  },
  mounted() {
    this.token = this.$route.query.token
    this.id = this.$route.query.id
  },
  computed: {
    ...mapState(['bucketUrl'])
  },
  methods: {
    async submit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        return // there are errors
      }
      try {
        let form = {
          id: this.id,
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.token
        }
        this.loading = true

        await Client.dispatch('acceptInvitation', {
          payload: form,
          axios: this.$axios
        })
        this.snackBarColor = 'green'
        this.snackbarMessage =
          'Invitation successfully accepted. Please, login now'
        this.snackbar = true

        setTimeout(() => {
          this.$router.push('/client/login')
        }, 3500)

        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.status === 422) {
          this.snackbarMessage = 'One of the fields could not be validated.'
        } else {
          this.snackbarMessage = 'Wrong username/password'
        }
        this.snackBarColor = 'error'
        this.snackbar = true
      }
    }
  }
}
</script>

<style lang="scss">
.client-accept-invitation {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
}
</style>
